import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'
import { TypographySmall } from '@/components/ui/typography'
import { ConferenceHub } from '@/types/ConferenceHub'
import { formatDateToString } from '@/utils/date'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Package, CircleDollarSign, FileSliders } from 'lucide-react';
import { currencyFormat, numberFormat } from '@/utils/stringFormatter';

interface AnalyzeDocumentDialogProps {
    isOpen: boolean
    onClose: () => void
    data: ConferenceHub
}

const AnalyzeDocument = ({ isOpen, onClose, data }: AnalyzeDocumentDialogProps) => {
 
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className='max-w-[800px] overflow-auto'  aria-describedby=''>
                <DialogHeader>
                    <DialogTitle className='flex gap-5 items-center px-5 pl-0'>
                        <span>Documento #{data.DD_DOCUMENTO} - {data.DD_SERIE}</span> 
                    </DialogTitle>
                    <DialogTitle className='flex gap-5 items-center px-5 pl-0'> 
                        <TypographySmall>Emissão: {formatDateToString(data.SK_TEMPO_EMISSAO)}</TypographySmall>
                        <TypographySmall>Digitação: {formatDateToString(data.SK_TEMPO_DIGITACAO)}</TypographySmall>
                    </DialogTitle>
                     <DialogTitle className='flex gap-5 items-center mt-4 px-5 pl-0'> 
                        <TypographySmall>Fornecedor: {data.DS_EMPRESA_FORNECEDOR}</TypographySmall>
                        <TypographySmall>Cliente: {data.DS_EMPRESA_CLIENTE}</TypographySmall>
                    </DialogTitle>
                </DialogHeader>
                <div className="grid gap-4 ">
                    <Card>
                        <CardHeader className="p-3">
                            <CardTitle className="flex items-center text-lg"> 
                                <Package className="w-5 h-5 mr-2" /> 
                                <div className={`mr-2 h-3 w-3 ${data.DD_PRODUTO_VALIDADO == 1 ? 'bg-completed' : 'bg-timeout'} rounded-md`} /> 
                                <span className='flex items-end'>Produto</span>  
                            </CardTitle>
                        </CardHeader>
                        <CardContent className="p-3 pt-0">
                            <dl className="space-y-2">
                                <dt className="text-sm font-medium text-muted-foreground">Fornecedor </dt>
                                <dd>{data.NK_PRODUTO_SAIDA} - {data.DS_PRODUTO_SAIDA} </dd>
                                <dt className="text-sm font-medium text-muted-foreground">Cliente</dt>
                                <dd>{data.NK_PRODUTO_ENTRADA} - {data.DS_PRODUTO_ENTRADA} </dd>
                            </dl>
                        </CardContent>
                    </Card> 
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <Card>
                        <CardHeader className="p-3">
                            <CardTitle className="flex items-center text-lg"> 
                                <Package className="w-5 h-5 mr-2" /> 
                                <div className={`mr-2 h-3 w-3 ${data.DD_QUANTIDADE_VALIDADO == 1 ? 'bg-completed' : 'bg-timeout'} rounded-md`} /> 
                                <span className='flex items-end'>Quantidade Produto</span>  
                            </CardTitle>
                        </CardHeader>
                        <CardContent className="p-3 pt-0">
                            <dl className="space-y-2">
                                <dt className="text-sm font-medium text-muted-foreground">Fornecedor</dt>
                                <dd>{numberFormat(data.QTD_PRODUTO_SAIDA)} </dd>
                                <dt className="text-sm font-medium text-muted-foreground">Cliente</dt>
                                <dd>{numberFormat(data.QTD_PRODUTO_ENTRADA)} </dd>
                            </dl>
                        </CardContent>
                    </Card> 

                    <Card>
                        <CardHeader className="p-3">
                            <CardTitle className="flex items-center text-lg"> 
                                <CircleDollarSign className="w-5 h-5 mr-2" /> 
                                <div className={`mr-2 h-3 w-3 ${data.DD_IPI_VALIDADO == 1 ? 'bg-completed' : 'bg-timeout'} rounded-md`} /> 
                                <span className='flex items-end'>Imposto IPI</span>  
                            </CardTitle>
                        </CardHeader>
                        <CardContent className="p-3 pt-0">
                            <dl className="space-y-2">
                                <dt className="text-sm font-medium text-muted-foreground">Fornecedor</dt>
                                <dd>{currencyFormat(data.VL_IMPOSTOS_SAIDA)} </dd>
                                <dt className="text-sm font-medium text-muted-foreground">Cliente</dt>
                                <dd>{currencyFormat(data.VL_IMPOSTO_ENTRADA)} </dd>
                            </dl>
                        </CardContent>
                    </Card> 

                    <Card>
                        <CardHeader className="p-3">
                            <CardTitle className="flex items-center text-lg"> 
                                <FileSliders className="w-5 h-5 mr-2" /> 
                                <div className={`mr-2 h-3 w-3 ${data.DD_CFOP_VALIDADO == 1 ? 'bg-completed' : 'bg-timeout'} rounded-md`} /> 
                                <span className='flex items-end'>CFOP</span>  
                            </CardTitle>
                        </CardHeader>
                        <CardContent className="p-3 pt-0">
                            <dl className="space-y-2">
                                <dt className="text-sm font-medium text-muted-foreground">Fornecedor</dt>
                                <dd>{data.DD_CFOP_SAIDA} </dd>
                                <dt className="text-sm font-medium text-muted-foreground">Cliente</dt>
                                <dd>{data.DD_CFOP_ENTRADA} </dd>
                            </dl>
                        </CardContent>
                    </Card> 

                </div>

            </DialogContent>
        </Dialog>
    )
}

export default AnalyzeDocument
